<script>
import { mapState, mapGetters } from 'vuex';
import { t } from '@/store/modules/homeDrushim/constantsContent';

/**
 * wizard steps
 */
import CvWizardStep1 from '@/components/CvWizard/CvWizardStep1/CvWizardStep1.vue';
import CvWizardStep2 from '@/components/CvWizard/CvWizardStep2/CvWizardStep2.vue';
import CvWizardStep3 from '@/components/CvWizard/CvWizardStep3/CvWizardStep3.vue';
import CvWizardStep4 from '@/components/CvWizard/CvWizardStep4/CvWizardStep4.vue';
import CvWizardStep5 from '@/components/CvWizard/CvWizardStep5/CvWizardStep5.vue';

export default {
  components: {
    CvWizardStep1,
    CvWizardStep2,
    CvWizardStep3,
    CvWizardStep4,
    CvWizardStep5,
  },
  props: {
    stepModel: {
      type: [String, Number],
      default: 1,
    },
  },
  data() {
    return {
      model: null,
      header: t`titles.cvWizard.header`,
      subHeader: t`titles.cvWizard.subHeader`,
      introText: t`titles.cvWizard.introText`,
    };
  },
  created() {
    this.model = this.stepModel;
  },

  computed: {
    ...mapState({
      auth: (state) => state.auth,
    }),
    ...mapGetters({
      getStepsperStatus: 'getStepsperStatus',
      getCVWStepContent: 'getCVWStepContent',
    }),
    isUserLogged() {
      return this.auth.loggedIn;
    },
  },
};
</script>
